<template>
  <div class="form-cont">
    <div class="form-headline">
      Möchtest du deine Rufnummer mitnehmen?
    </div>
    <div class="form-fields">
      <BaseGridRow>
        <BaseGridCol>
          <BaseGridRow small>
            <BaseGridCol>
              <Checkbox
                  v-model="form.isNumberTransfer"
                  v-model:error="errors.isNumberTransfer"
              >
                Ich möchte meine Rufnummer mitnehmen.
              </Checkbox>
            </BaseGridCol>
            <BaseGridCol
                v-if="form.isNumberTransfer"
                :s="{ xs: 12, xxl: 6 }"
            >
              <SelectField
                  label="Altanbieter*"
                  search
                  :options="currentProviderOptions"
                  v-model="form.currentProvider"
                  v-model:error="errors.currentProvider"
              />
            </BaseGridCol>
            <BaseGridCol
                v-if="form.isNumberTransfer"
                :s="{ xs: 12, xxl: 6 }"
            >
              <InputField
                  label="Rufnummer*"
                  v-model="form.phoneNumber"
                  v-model:error="errors.phoneNumber"
              />
            </BaseGridCol>
            <BaseGridCol v-if="form.isNumberTransfer">
              <Checkbox
                  v-model="form.allowCancellation"
                  v-model:error="errors.allowCancellation"
              >
                Ich ermächtige die Stadtwerke Ahrensburg GmbH, die erforderliche Kündigung bei meinem derzeitigen
                Telekommunikationsanbieter für mich vorzunehmen.
              </Checkbox>
            </BaseGridCol>
            <BaseGridCol v-if="form.isNumberTransfer">
              <Checkbox
                  v-model="form.notIsConnectionOwner"
                  v-model:error="errors.notIsConnectionOwner"
              >
                Ich bin nicht Anschlussinhaber:in.
              </Checkbox>
            </BaseGridCol>
          </BaseGridRow>
        </BaseGridCol>
        <BaseGridCol v-if="form.isNumberTransfer && form.notIsConnectionOwner">
          <BaseGridRow small>
            <BaseGridCol>
              <Headline tag-name="div" size="h6" text-align="start" bold>
                Anschlussinhaber:in
              </Headline>
            </BaseGridCol>
            <BaseGridCol :s="{ xs: 12, xxl: 6 }">
              <InputField
                  label="Vorname*"
                  v-model="form.connectionOwner.firstName"
                  v-model:error="errors['connectionOwner.firstName']"
              />
            </BaseGridCol>
            <BaseGridCol :s="{ xs: 12, xxl: 6 }">
              <InputField
                  label="Nachname*"
                  v-model="form.connectionOwner.lastName"
                  v-model:error="errors['connectionOwner.lastName']"
              />
            </BaseGridCol>
            <BaseGridCol>
              <AppAddressFields
                  v-model:postcode="form.connectionOwner.postcode"
                  v-model:error-postcode="errors['connectionOwner.postcode']"
                  v-model:city="form.connectionOwner.city"
                  v-model:error-city="errors['connectionOwner.city']"
                  v-model:street="form.connectionOwner.street"
                  v-model:error-street="errors['connectionOwner.street']"
                  v-model:house-number="form.connectionOwner.houseNumber"
                  v-model:error-house-number="errors['connectionOwner.houseNumber']"
                  v-model:house-number-addon="form.connectionOwner.houseNumberAddon"
                  v-model:error-house-number-addon="errors['connectionOwner.houseNumberAddon']"
              />
            </BaseGridCol>
          </BaseGridRow>
        </BaseGridCol>
      </BaseGridRow>
    </div>
    <div>
      <AppOrderActions
          :labels="{
            previous: 'Zurück',
            next: form.isNumberTransfer ? 'Weiter' : 'Ohne Rufnummermitnahme weiter',
          }"
          @previous="emit('previous')"
          @next="emit('next')"
          :color-next="product.branch"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import Product from '@/classes/Product';
import BaseGridCol from '@/components/BaseGridCol.vue';
import BaseGridRow from '@/components/BaseGridRow.vue';
import Checkbox from '@/components/Checkbox.vue';
import Headline from '@/components/Headline.vue';
import InputField from '@/components/InputField.vue';
import AppAddressFields from '@/components/inputs/AppAddressFields.vue';
import AppOrderActions from '@/components/order/order/AppOrderActions.vue';
import SelectField from '@/components/SelectField.vue';

defineProps<{
  product: Product
}>();

const form = defineModel<Record<string, any>>();
const errors = defineModel<Record<string, string | undefined>>('errors');

const currentProviderOptions = [
  'Telekom Deutschland GmbH',
  'Vodafone GmbH',
  'Vodafone Kabel Deutschland GmbH',
  'O² / Telefónica Germany GmbH & Co.',
  '1&1 Telecom GmbH',
  '1&1 Versatel Deutschland GmbH',
  'Tele2 GmbH',
  'Congstar GmbH',
  'Sonstiger Anbieter',
];

const emit = defineEmits(['previous', 'next']);
</script>

<style scoped lang="scss">
@import 'src/scss/component-helpers';

.form-cont {
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto 1fr auto;

  > div {
    padding: var(--modal-card-padding-x);
  }

  .form-headline {
    font-size: 1rem;
    font-weight: 700;
    padding-bottom: 0;

    @media (min-width: map_get($grid-breakpoints, 'lg')) {
      font-size: 1.25rem;
    }
  }
}
</style>
